import { FC } from 'react'
import Image from 'next/image'

interface ChatbotFloatingButtonProps {
  onClick: () => void
}

export const ChatbotFloatingButton: FC<ChatbotFloatingButtonProps> = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      className="fixed bottom-6 right-6 w-16 h-16 border-none cursor-pointer z-20 transition-all hover:scale-110 hidden sm:flex items-center justify-center group bg-transparent [body[data-holding-drawer=open]_&]:!hidden [body[data-pre-ipo-fund-scroll]_&]:!hidden"
      aria-label="Open chat"
    >
      <Image
        src="/images/icons/ChatbotIconWht.webp"
        alt="Open chat assistant"
        className="h-auto group-hover:scale-110 transition-transform"
        fill
        sizes="64px"
      />

      <div className="absolute -top-1 -right-1 w-4 h-4 bg-green-400 rounded-full animate-pulse border-2 border-white"></div>
    </button>
  )
}
